import { Component, Input } from '@angular/core';

@Component({
  selector: 'ss-kpi',
  template: `
    <article class="ss-kpi" [class.ss-kpi--highlight]="highlight">
      <div class="ss-kpi__label">
        {{ label }}
        <button *ngIf="help" type="button" class="ss-badge ss-badge--info" [ssTooltip]="help" [attr.aria-label]="help">i</button>
      </div>
      <strong class="ss-kpi__value" [class.ss-kpi__value--money]="money && !highlight">{{ value }}</strong>
      <span *ngIf="description" class="ss-kpi__description">{{ description }}</span>
      <ng-content></ng-content>
    </article>
  `,
  standalone: false
})
export class KpiComponent {
  @Input() label = '';
  @Input() value: string | number | null = '';
  @Input() description = '';
  @Input() highlight = false;
  @Input() money = false;
  @Input() help = '';
}
